import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * ProjectionWidget - Widget para mostrar proyección de ingresos
 * @param {number} amount - Monto proyectado
 * @param {number} count - Cantidad de pagos próximos
 */
const ProjectionWidget = ({ amount = 0, count = 0 }) => {
    const { t, i18n } = useTranslation();

    const formatCurrency = (val) => {
        return '$' + parseFloat(val || 0).toLocaleString(i18n.language, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: 'decimal'
        });
    };

    return (
        <Card className="bg-light border-primary h-100">
            <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <Card.Title className="text-primary">
                        {t('dashboard.revenueProjection')}
                    </Card.Title>
                    <Badge bg="primary" pill>30 {t('dashboard.days')}</Badge>
                </div>

                <h2 className="display-5 fw-bold text-dark mb-1">
                    {formatCurrency(amount)}
                </h2>

                <div className="text-muted mb-3">
                    {t('dashboard.projectedIncome')}
                </div>

                <div className="d-flex align-items-center text-primary">
                    <span className="fs-4 me-2">📅</span>
                    <strong>{count}</strong>
                    <span className="ms-1">{t('dashboard.upcomingPayments')}</span>
                </div>
            </Card.Body>
        </Card>
    );
};

export default ProjectionWidget;
